    <div class="header">
      <mat-expansion-panel [expanded]="isExpanded" [hidden]="!isLoaded">
        <mat-expansion-panel-header style="height: 90px;">
          <mat-panel-description>
            <div style="width: 100%;">
              <div class="title" *ngIf="id || title">
                <span *ngIf="id">【ID: {{ id }}】 </span>
                <span *ngIf="title">{{ title }} </span>
                  @if (isEnableEmailUpdate && user_id && email) {
                    @if (!isEmailUpdate) {
                      <span style="margin-left: 20px;" *ngIf="email">
                        <button type="button" (click)="isEmailUpdate=true">Email 変更</button>
                      </span>
                    } @else {
                      <div>
                        <span style="font-size: 16px;">新Email : </span><input #mail type="email" [value]="email" style="font-size: 16px; width: 85%; margin-right: 10px;"> 
                        <button type="button" (click)="updateEmail(user_id, mail.value)">保存</button>
                      </div>
                    }
                  }
              </div>
              <div class="meta" *ngIf="name||login||status||priority">
                <span style="display: inline; margin-right: 1em; font-size: 18px;">{{ name ? name + ' (' + login + ')' : login }} 様</span>
                <a *ngIf="user_id" (click)="blankOpen($event, '/client/monthlyReport?uid=' + user_id)">月報</a>
                <span style="display: inline; margin-right: 0.5em;"></span>
                <app-label-chip [status]="status" *ngIf="status"></app-label-chip>
                <span style="display: inline; margin-right: 0.5em;"></span>
                <app-label-chip [status]="priority" *ngIf="priority"></app-label-chip>
              </div>
            </div>
          </mat-panel-description>
        </mat-expansion-panel-header>

        @if (reports) {
          <div class="list-section">
            <div class="list-header">
              口座一覧
              （<a href="javascript:void(0)" (click)="changeAd(prevAd!)">⇐</a> {{getAdToYm(currentAd)}} <a href="javascript:void(0)" (click)="changeAd(nextAd!)">⇒</a>）
            </div>

            <div class="table-scroll">
              <table border="1" class="list">
                <thead>
                  <tr>
                    <th>口座番号</th><th>POOL</th><th>通貨</th><th>手数料</th><th>調整額</th><th>その他手数料</th><th>年金出金</th><th>出金</th><th>振替</th><th>月末残高</th><th>共同名義</th><th>備考</th>
                  </tr>
                </thead>
                <tbody>
                @if (reports.length > 0) {
                  @for (obj of reports; track obj) {
                    <tr>
                      <td nowrap class="col-capid">{{obj.cap_id}}</td>
                      <td nowrap class="col-pool">{{getPool(obj.cap_id)}}</td>
                      <td nowrap class="col-cur">{{obj.cur}}</td>
                      <td nowrap class="col-fee col-numeric">{{rateToPercent(obj.hdc)}} %</td>
                      <td nowrap class="col-adjust col-numeric">
                        <div [title]="obj.adjust_comment" [ngClass]="{'col-negative': obj.adjust_amount < 0}">{{formatDecimalTrim(obj.adjust_amount)}}</div>
                      </td>
                      <td nowrap class="col-hc_b col-numeric">
                        <div [title]="obj.hc_b_comment" [ngClass]="{'col-negative': obj.hc_b < 0}">{{formatDecimalTrim(obj.hc_b)}}</div>
                      </td>
                      <td nowrap class="col-pension col-numeric" [ngClass]="{'col-negative': obj.pension < 0}">{{formatDecimalTrim(obj.pension)}}</td>
                      <td nowrap class="col-shukkin col-numeric" [ngClass]="{'col-negative': obj.shukkin < 0}">{{formatDecimalTrim(obj.shukkin)}}</td>
                      <td nowrap class="col-transfer col-numeric">
                        <div [title]="transferTitle(obj)" [ngClass]="{'col-negative': obj.transfer_amount < 0}">{{formatDecimalTrim(obj.transfer_amount)}}</div>
                      </td>
                      <td nowrap class="col-balance col-numeric" [ngClass]="{'col-negative': obj.bal_b < 0}">{{formatDecimalTrim(obj.bal_b)}}</td>
                      <td nowrap class="col-cmm">{{obj.cmm}}</td>
                      <td class="col-note">{{obj.note}}</td>
                    </tr>
                  }
                }
                @else {
                  <tr><td colspan="12">データはありません</td></tr>
                }
                </tbody>
              </table>
            </div>
          </div>
        }

        @if (transactions) {
          <div class="list-section">
            <div class="list-header">
              送金処理管理一覧
            </div>

            <div class="table-scroll">
              <table border="1" class="list">
                <thead>
                  <tr>
                    <th>出金額確定日時(登録日時)</th><th>出金依頼ID(クリックで出金依頼詳細)</th><th>通貨</th><th>出金確定額</th><th>送金済</th><th>未送金</th>
                  </tr>
                </thead>
                <tbody>
                @if (transactions.length > 0) {
                  @for (obj of transactions; track obj) {
                    <tr class="clickable-row" (click)="openTransaction(obj)">
                      <td nowrap class="col-capid">{{formatDate(obj.created_at.toString())}}</td>
                      <td nowrap class="col-inquiry">
                        @if (obj.inquiry) {
                          <button style="width: 100%;" (click)="$event.stopImmediatePropagation();open(obj.inquiry)">
                            <span [title]="obj.inquiry.first_child?.body" style="display: block; text-align: left; width: 100%; height: 100%; cursor: help;">📄&nbsp;{{obj.inquiry.id}}　{{obj.inquiry.title}}</span>
                          </button>
                        }
                        @else {
                          <div [title]="obj.alt_body">単独作成・{{transactionAlt(obj)}}</div>
                        }
                      </td>
                      <td nowrap class="col-cur">{{obj.currency}}</td>
                      <td nowrap class="col-numeric" [ngClass]="{'col-negative': obj.requested_amount < 0}">{{formatDecimalTrim(obj.requested_amount)}}</td>
                      <td nowrap class="col-numeric" [ngClass]="{'col-negative': obj.settled_amount < 0}">{{formatDecimalTrim(obj.settled_amount)}}</td>
                      <td nowrap class="col-numeric" [ngClass]="{'col-negative': obj.unpaid_amount < 0}">{{formatDecimalTrim(obj.unpaid_amount)}}</td>
                    </tr>
                  }
                }
                @else {
                  <tr><td colspan="6">データはありません</td></tr>
                }
                </tbody>
              </table>
            </div>
          </div>

        }

        @if (inquiries) {
          <div class="list-section">
            <div class="list-header">お問い合わせ一覧</div>

            <div class="table-scroll">
              <table border="1" class="list">
                <thead>
                  <tr>
                    <th>受付日時</th><th>分類</th><th>タイトル</th><th>AI要約</th><th>管理者メモ</th><th>状態</th><th>優先度</th>
                  </tr>
                </thead>
                <tbody>
                @if (inquiries.length > 0) {
                  @for (obj of inquiries; track obj) {
                    <tr class="clickable-row" (click)="open(obj)">
                      <td class="col-date">{{formatDate(obj.created_at.toString())}}</td>
                      <td class="col-sub-category">{{obj.sub_category}}</td>
                      <td class="col-title">{{obj.title}}</td>
                      <td class="col-summary">{{obj.first_child_summary}}</td>
                      <td class="col-remark">{{obj.remark}}</td>
                      <td class="col-status"><app-label-chip [status]="obj.status"></app-label-chip></td>
                      <td class="col-status"><app-label-chip [status]="obj.priority"></app-label-chip></td>
                    </tr>
                  }
                }
                @else {
                  <tr><td colspan="7">データはありません</td></tr>
                }
                </tbody>
              </table>
            </div>
          </div>
        }

        @if (withdrawals) {
          <div class="list-section">
            <div class="list-header">出金依頼一覧</div>

            <div class="table-scroll">
              <table border="1" class="list">
                <thead>
                  <tr>
                    <th>受付日時</th><th>分類</th><th>タイトル</th><th>AI要約</th><th>管理者メモ</th><th>状態</th><th>優先度</th>
                  </tr>
                </thead>
                <tbody>
                @if (withdrawals.length > 0) {
                  @for (obj of withdrawals; track obj) {
                    <tr class="clickable-row" (click)="open(obj)">
                      <td class="col-date">{{formatDate(obj.created_at.toString())}}</td>
                      <td class="col-sub-category">{{obj.sub_category}}</td>
                      <td class="col-title">{{obj.title}}</td>
                      <td class="col-summary">{{obj.first_child_summary}}</td>
                      <td class="col-remark">{{obj.remark}}</td>
                      <td class="col-status"><app-label-chip [status]="obj.status"></app-label-chip></td>
                      <td class="col-status"><app-label-chip [status]="obj.priority"></app-label-chip></td>
                    </tr>
                  }
                }
                @else {
                  <tr><td colspan="7">データはありません</td></tr>
                }
                </tbody>
              </table>
            </div>
          </div>
        }

        @if (transfers) {
          <div class="list-section">
            <div class="list-header">振替依頼一覧</div>

            <div class="table-scroll">
              <table border="1" class="list">
                <thead>
                  <tr>
                    <th>受付日時</th><th>分類</th><th>タイトル</th><th>AI要約</th><th>管理者メモ</th><th>状態</th><th>優先度</th>
                  </tr>
                </thead>
                <tbody>
                @if (transfers.length > 0) {
                  @for (obj of transfers; track obj) {
                    <tr class="clickable-row" (click)="open(obj)">
                      <td class="col-date">{{formatDate(obj.created_at.toString())}}</td>
                      <td class="col-sub-category">{{obj.sub_category}}</td>
                      <td class="col-title">{{obj.title}}</td>
                      <td class="col-summary">{{obj.first_child_summary}}</td>
                      <td class="col-remark">{{obj.remark}}</td>
                      <td class="col-status"><app-label-chip [status]="obj.status"></app-label-chip></td>
                      <td class="col-status"><app-label-chip [status]="obj.priority"></app-label-chip></td>
                    </tr>
                  }
                }
                @else {
                  <tr><td colspan="7">データはありません</td></tr>
                }
                </tbody>
              </table>
            </div>
          </div>
        }

        @if (invests) {
          <div class="list-section">
            <div class="list-header">新規出資依頼一覧</div>

            <div class="table-scroll">
              <table border="1" class="list">
                <thead>
                  <tr>
                    <th>受付日時</th><th>分類</th><th>タイトル</th><th>AI要約</th><th>管理者メモ</th><th>状態</th><th>優先度</th>
                  </tr>
                </thead>
                <tbody>
                @if (invests.length > 0) {
                  @for (obj of invests; track obj) {
                    <tr class="clickable-row" (click)="open(obj)">
                      <td class="col-date">{{formatDate(obj.created_at.toString())}}</td>
                      <td class="col-sub-category">{{obj.sub_category}}</td>
                      <td class="col-title">{{obj.title}}</td>
                      <td class="col-summary">{{obj.first_child_summary}}</td>
                      <td class="col-remark">{{obj.remark}}</td>
                      <td class="col-status"><app-label-chip [status]="obj.status"></app-label-chip></td>
                      <td class="col-status"><app-label-chip [status]="obj.priority"></app-label-chip></td>
                    </tr>
                  }
                }
                @else {
                  <tr><td colspan="7">データはありません</td></tr>
                }
                </tbody>
              </table>
            </div>
          </div>
        }

        <!--
        @if (withdrawals && withdrawals.length > 0) {
          <div>
            出金依頼
            <table border="1" class="account">
              <tr>
                <th>更新日時</th><th>依頼日時</th><th>口座番号</th><th>出金タイプ</th><th>金額</th><th>通貨</th><th>出金予定日</th><th>状態</th>
              </tr>
              @for (withdrawal of withdrawals; track withdrawal) {
                <tr [ngClass]="{'match-cap-id': withdrawal.cap_id === cap_id}">
                  <td>{{formatDate(withdrawal.updated_at.toString())}}</td>
                  <td>{{formatDate(withdrawal.created_at.toString())}}</td>
                  <td>{{withdrawal.cap_id}}</td>
                  <td>{{withdrawal.method}}</td>
                  <td style="text-align: right;">{{withdrawal.amount | number:'1.0-2'}}</td>
                  <td>{{withdrawal.cur}}</td>
                  <td>{{withdrawal.date}}</td>
                  <td>{{withdrawal.status}}</td>
                </tr>
              }
            </table>
          </div>
        }
        @else if (isLoaded) {
          <div style="">出金依頼は運用開始前です</div>
        }
        -->

      </mat-expansion-panel>
    </div>

